import React from 'react';
import OriginalLogoSymbolRemovebg from '../images/OriginalLogoSymbolRemovebg.png';
import { BsArrowRightSquare } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';

const Sidebar = ({ admin, clientTextBox, updateStep, setUpdateStep }) => {
  const { t } = useTranslation();

  const goToStep = (step) => {
    window.scrollTo({ top: step * 80, behavior: 'smooth' });
    setUpdateStep(step);
  };
  return (
    <div>
      <div className="fixed left-14 self-center">
        <img
          src={OriginalLogoSymbolRemovebg}
          alt="Logo"
          className="object-contain h-36"
        />
      </div>
      <div className="p-4 fixed top-36 bottom-0 overflow-y-auto w-72">
        <ul className="space-y-2">
          {admin && <div className="text-white text-lg pb-3">Taxpayer</div>}
          {clientTextBox?.map((curValue, i) => {
            return (
              <li key={i}>
                <div
                  className="flex pl-2 pb-2 cursor-pointer items-center text-base font-normal text-white hover:bg-transparent hover:text-blue-300"
                  onClick={() => goToStep(curValue.id)}
                >
                  {curValue.id === updateStep && (
                    <BsArrowRightSquare size={16} />
                  )}
                  <span className="flex-1 ml-3 whitespace-nowrap">
                    {t(curValue.label)}
                  </span>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
